import { ArticleHeading4, UIText1, UIText2 } from '@cian/ui-kit';
import cx from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

interface IKeyValTableProps {
  title?: string | null;
  className?: string;
  table: Array<{ title: React.ReactNode; value: React.ReactNode }>;
  size?: 'M' | 'XS';
}

export const KeyValTable: React.FC<IKeyValTableProps> = ({ title, table, className, size }) => {
  const Text = size === 'M' ? UIText1 : UIText2;

  return (
    <div className={cx(styles['container'], className)}>
      {title && <ArticleHeading4 as="P">{title}</ArticleHeading4>}

      <div className={styles['wrapper']}>
        {table.map(({ title, value }) => (
          <React.Fragment key={String(title)}>
            <Text color="text-secondary-default">{title}</Text>
            <Text>{value}</Text>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
